import { Component, HostListener, OnInit } from '@angular/core';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  

  headerStickyFlag:boolean = false;
  navHoverFlag:boolean = false;
  visibleFlag:boolean= false;

  constructor() { }

  ngOnInit(): void {
    window.addEventListener('scroll', this.scroll);
  }


  scroll= (event:any) =>{
    let scrolllotation = document.documentElement.scrollTop;

    if(scrolllotation > 0 ){
      this.headerStickyFlag = true;
    }
    else{
      if(!this.navHoverFlag)
        this.headerStickyFlag = false;
        this.visibleFlag = false;
    }
  }

  mouseHover(){

    if(!this.navHoverFlag)
        this.navHoverFlag = true;
  
    this.headerStickyFlag = true;

  }

  mouseLeave(){

    if(this.navHoverFlag)
        this.navHoverFlag = false;
  }

  clickRemove(){

          this.navHoverFlag = false;
        this.headerStickyFlag = false;
        this.visibleFlag = false;
  }
  clickBar(){
    if(this.visibleFlag)
      this.visibleFlag=false;
    else{
      this.headerStickyFlag=true;
      this.visibleFlag = true;
    }
    
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scroll, true);
}


}
